export const holdingUnitEventEntityTypeValues = [
  'holdingUnit',
  'loadSession',
  'fixedIdAsset',
] as const;

export type HoldingUnitEventEntityType = (typeof holdingUnitEventEntityTypeValues)[number];

export const holdingUnitEventOriginKindValues = ['desktop', 'cloud'] as const;

export type HoldingUnitEventOriginKind = (typeof holdingUnitEventOriginKindValues)[number];

export interface HoldingUnitEventOrigin {
  kind: HoldingUnitEventOriginKind;
  deviceId: string | null;
  deviceClaimId: string | null;
}

export interface HoldingUnitEventEnvelopeBase {
  entityType: HoldingUnitEventEntityType;
  entityId: string;
  eventType: string;
  eventSchemaVersion: 1;
  streamVersion: number;
  eventId: string;
  commandId: string;
  commandType: string;
  correlationId?: string | null;
  causationId?: string | null;
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  actorUserId: string;
  occurredAt: string; // ISO datetime
  origin: HoldingUnitEventOrigin;
  payload: unknown;
}
